<template>
	<app-table
		class="mt-2 is-not-selectable"
		:columns="columns"
		:current-page="currentPage"
		:items-quantity="itemsQuantity"
		:items-total-quantity="itemsTotalQuantity"
		:last-page="lastPage"
		:filter-columns="false"
		:number-seats="numberSeats"
		name="ledger"
		padding="px-0"
		:rows="rows"
		@on-page="$emit('on-page', $event)"
		@on-search-event="$emit('on-search', $event)"
		@row-on-click="$emit('row-on-click', $event)"
	>
		<template slot="rows" slot-scope="props">
			<td	class="is-not-selectable"
				v-show="showRow(columns, 1)">
				<input
					:id="`row-${props.row.id}-${props.index}`"
					hidden
					@keyup.up="$emit('up-selected', props.row)"
					@keyup.down="$emit('down-selected', props.row)"
				/>
				{{ props.row.accountingSeat.date || null | exactDate }}
			</td>
			<td v-show="showRow(columns, 2)">{{ props.row.accountingSeat.code  || null}}</td>
			<td v-show="showRow(columns, 3)">{{ props.row.reference || null }}</td>
			<td v-show="showRow(columns, 4)">{{ props.row.concept || null }}</td>
			<td class="text-xs-right pr-1" v-show="showRow(columns, 5)">{{ props.row.amountDebe || 0 | formatAmount }}</td>
			<td class="text-xs-right pr-1" v-show="showRow(columns, 6)">{{ props.row.amountHaber || 0 | formatAmount }}</td>
			<td v-show="showRow(columns, 6)">{{ props.row.accountingAccount.name}}</td>
		</template>
	</app-table>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function data() {
	return {
		columns: [
			{
				id: 1,
				name: 'Fecha',
				value: 'date',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Asiento',
				value: 'seatCode',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 3,
				name: 'Referencia',
				value: 'reference',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 4,
				name: 'Concepto',
				value: 'concept',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 5,
				name: 'Debe',
				value: 'totalDebt',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 6,
				name: 'Haber',
				value: 'totalHaber',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 7,
				name: 'Origen',
				value: 'origin',
				checked: true,
				visible: true,
				movil: true,
			},
		],
		iconWidth: 12,
	};
}

export default {
	name: 'ledger-list',
	components: {
		appTooltipButton,
	},
	data,
	props: {
		currentPage: {
			type: Number,
			default: 1,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
		numberSeats: {
			type: Number,
			default: 0,
		},
		itemsQuantity: {
			type: Number,
			default: 0,
		},
		itemsTotalQuantity: {
			type: Number,
			default: 0,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/ledger/ledger-list.vue